module.exports = __webpack_public_path__ + "img/icon_map_3_yj.ca1ff483.png";